// extracted by mini-css-extract-plugin
export default {"input":"_15zqLl7s","label":"_1SzENz9f","text":"_1j1BREfR","switch":"_1zT3poUy","knob":"Syfdan27"};